import { lazy } from 'react';

// ----------------------------------------------------------------------

export const LoginPage = lazy(() => import('src/pages/auth/login'));
export const ForgotPasswordPage = lazy(() => import('src/pages/auth/forgot-password'));
export const VerifyEmailPage = lazy(() => import('src/pages/auth/verify-email'));
export const ResetPasswordPage = lazy(() => import('src/pages/auth/reset-password'));
export const Page500 = lazy(() => import('src/pages/500'));
export const Page403 = lazy(() => import('src/pages/403'));
export const Page404 = lazy(() => import('src/pages/404'));
